import { ActionController, ActionControllerEventName } from "@g.frame/common.action_controller";
import { ParentEvent, ViewerModule } from "@g.frame/core";
import { DesktopModule } from "@g.frame/desktop";
import { Mesh, MeshBasicMaterial, PlaneBufferGeometry, Vector3 } from "three";
export default class PlungerDrag extends ViewerModule {
    constructor(syringe, plunger, modulesProcessor) {
        super();
        this.syringe = syringe;
        this.plunger = plunger;
        this.modulesProcessor = modulesProcessor;
        this.actionController = this.modulesProcessor.agents.get(ActionController);
        this.controls = this.modulesProcessor.modulesInstances.get(DesktopModule)[1];
    }
    initDrag() {
        const WP = this.syringe.position.clone();
        if (!this.syringe.userData.dragPlane) {
            this.dragPlane = new Mesh(new PlaneBufferGeometry(0.2, 0.5), new MeshBasicMaterial({ color: '#66ee66', side: 2, visible: false }));
            this.syringe.userData.dragPlane = this.dragPlane;
            this.syringe.add(this.syringe.userData.dragPlane);
        }
        const dragPlane = this.syringe.userData.dragPlane;
        let dragEnabled = false;
        this.actionController.on(ActionControllerEventName.buttonDown, this.plunger, (event) => {
            dragEnabled = true;
            this.controls.enabled = false;
            this.startPosition = new Vector3().subVectors(event.data.intersection.point, WP).y;
        });
        this.actionController.on(ActionControllerEventName.buttonUp, this.plunger, () => {
            dragEnabled = false;
            this.controls.enabled = true;
            this.fire('plunger_move_end', new ParentEvent('plunger_move_end'));
        });
        this.actionController.on(ActionControllerEventName.move, dragPlane, (event) => {
            if (dragEnabled) {
                const dragPoint = new Vector3().subVectors(event.data.intersection.point, WP).y;
                const offset = dragPoint - this.startPosition;
                this.fire('plunger_move', new ParentEvent('plunger_move', { offset: offset }));
            }
        });
        this.actionController.on(ActionControllerEventName.out, dragPlane, () => {
            dragEnabled = false;
            this.controls.enabled = true;
            this.fire('plunger_move_end', new ParentEvent('plunger_move_end'));
        });
    }
    removeDrag() {
        this.syringe.remove(this.syringe.userData.dragPlane);
        this.syringe.userData.dragPlane = null;
    }
    removeEvents() {
        this.off('plunger_move');
        this.off('plunger_move_end');
        this.actionController.off(ActionControllerEventName.buttonDown, this.plunger);
        this.actionController.off(ActionControllerEventName.buttonUp, this.plunger);
        this.actionController.off(ActionControllerEventName.move, this.dragPlane);
        this.actionController.off(ActionControllerEventName.out, this.dragPlane);
        this.controls.enabled = true;
    }
}
